// extracted by mini-css-extract-plugin
export default {"button":"Button_button__EFDZD","shadow":"Button_shadow__Uf9c9"};